module.exports = __webpack_public_path__ + "img/1down.efce735c.png";